import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Alert } from "react-bootstrap";
import { Button } from "react-bootstrap";
import '../Styles/Login.css';
import { CustomEvent, serviceCall } from "../Utils/ServiceUtils";

const Login = () => {
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [forgotPass, setForgotPass] = useState(false);

  useEffect(() => {
    window.localStorage.clear();
    window.localStorage.setItem("CartDetails", JSON.stringify([]));
    window.dispatchEvent(CustomEvent("storage", { "detail": { "key": "Cart" } }));
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    let reqBody = {
      "UserName": userName,
      "Password": password
    }
    const resp = await serviceCall("POST", "/API/Account/Login", reqBody);
    if(resp?.IsError === true) {
      setError(resp?.Message);
    } else if(resp?.IsError === false && resp?.Result){
      window.localStorage.setItem("Content",JSON.stringify(resp.Result));
      window.location.href = window.location.origin + "/Home";
    }
  };

  const forgotPassword = async (e) => {
    e.preventDefault();
    setError("");
    const resp = await serviceCall("GET", "/API/Account/ForgotPassowrd?Email=" + email);
    setError(resp);
  };

  return (
    <>
      <div className="loginBackground">
        <Link to="/Home" style={{ textDecoration: "none", color: "rgb(33,37,41)" }}>
          <div className="loginSignUpLogo"></div>
        </Link>
        <div className="container login">
          <div className="text-center">
            {!forgotPass && <Form onSubmit={handleSubmit}>
              <h2 className="title p-4">Login</h2>
              <Form.Group className="mb-4" controlid="formBasicEmail">
                <Form.Control
                  type="userName"
                  placeholder="Username"
                  className="input"
                  onChange={(e) => setUserName(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-4" controlid="formBasicPassword">
                <Form.Control
                  type="password"
                  placeholder="Password"
                  className="input"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <div className="mb-4 d-flex" style={{justifyContent: "space-between"}}>
                <Button variant="primary" type="Submit" className="btn l0gin" disabled={!userName || !password}>
                  Log In
                </Button>
                <div className="mt-3 forgotPass" onClick={() => (setForgotPass(true), setError(""))}>
                  <Link to="/Login"> Forgot your Password?</Link>
                </div>
              </div>
              {error && <Alert variant="danger" className="errorMgT">{error}</Alert>}
              <div className="p-3 noAcc">
                Don't have an account? <Link to="/signup"> Sign up</Link>
              </div>
            </Form>}
            {forgotPass && <Form onSubmit={forgotPassword}>
              <h4 className="title p-4">Enter Email Address</h4>
              <Form.Group className="mb-4" controlid="formBasicEmail">
                <Form.Control
                  type="email"
                  placeholder="Email address"
                  className="input"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <div className="mb-4 d-flex" style={{justifyContent: "space-between"}}>
                <Button variant="primary" type="Submit" className="btn l0gin" disabled={!email}>
                  Submit
                </Button>
                <div className="mt-3 forgotPass" onClick={() => (setForgotPass(false), setError(""))}>
                  Back to Sign in? <Link to="/Login"> Sign in</Link>
                </div>
              </div>
              {error && <Alert variant={`${error.Message.includes("successfully") ? "success" : "danger"}`} className="mT10">{error.Message}</Alert>}
            </Form>}

          </div>
        </div>
      </div>
    </>
  );
};

export default Login;